import { BaseURl } from "./BaseApiUrl";

//https://testcockpit.p2k.in/api/userdetails/RepVerifierWiseCurrentCallingStatus/v1/?userUUID=106c67c4-f015-11ee-91f2-b8ca3ad15bed
export const getVerifierWiseCurrentCallingStatus = BaseURl + "userdetails/RepVerifierWiseCurrentCallingStatus/v1/";